/**
 * Aircraft status options for dropdown selections
 */
export const AIRCRAFT_STATUS_OPTIONS = [
  { value: 'Available', label: 'Available' },
  { value: 'Under Contract', label: 'Under Contract' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Sold Pending', label: 'Sold Pending' },
  { value: 'Contract Pending', label: 'Contract Pending' },
  { value: 'In Escrow', label: 'In Escrow' },
  { value: 'Reserved', label: 'Reserved' },
  { value: 'Sold', label: 'Sold' },
  { value: 'Withdrawn', label: 'Withdrawn' },
  { value: 'Off Market', label: 'Off Market' },
  { value: 'Not For Sale', label: 'Not For Sale' },
  { value: 'Leased', label: 'Leased' },
  { value: 'Demo', label: 'Demo' },
  { value: 'Maintenance', label: 'Maintenance' },
  { value: 'Unknown', label: 'Unknown' }
] as const

/**
 * Type for aircraft status values
 */
export type AircraftStatusValue = typeof AIRCRAFT_STATUS_OPTIONS[number]['value']
